import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
// import 'babel-polyfill'

Vue.config.productionTip = false
//导入轮播图组件
import VueAwesomeSwiper from 'vue-awesome-swiper';

Vue.use(VueAwesomeSwiper);
import 'swiper/dist/css/swiper.css'

// 公用js
import utils from '../static/js/utils.js';
Vue.prototype.utils=utils
Vue.use(utils);

// 配置文件
import config from '../static/js/config.js';
Vue.prototype.config=config
Vue.use(config);


// import echarts from '../static/js/echarts.min';
// Vue.prototype.$echarts = echarts
// Vue.use(echarts);

import VueResource from 'vue-resource'
Vue.use(VueResource)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})
//跳转到页面的顶部位置
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});




// WEBPACK FOOTER //
// ./src/main.js